import { DARK_WEB, DARK_WEB_GRAPH } from "../actions";

export default function (
  state = {
    loading: true,
    response: null,
  },
  action
) {

  switch (action.type) {
    case DARK_WEB:
      return {
        ...state,
        response: action.payload,
        loading: false,
        scanCompleted: action.payload.scanCompleted,
      };
    case DARK_WEB_GRAPH:
      return {
        ...state,
        darkWebGraph: action.payload
      };
    default:
      return state;
  }
}
